import DA from './da'
import EN from './en'

export { DA }
export { EN }



// WEBPACK FOOTER //
// ./src/assets/lang/index.js